const theme = {
  breakpoints: [
    480,
    768,
    1024,
    1300
  ],
  space: [
    0,
    4,
    8,
    16,
    32,
    48,
    64,
    110,
    128,
  ],
  fonts: {
    sans: 'Arial,Adobe Garamond',
    mono: 'Menlo, monospace',
  },
  fontSizes: [
    12,
    14,
    16,
    20,
    24,
    32,
    48,
    64,
    72,
    96
  ],
  weights: {
    normal: 400,
    bold: 700
  },
  borders: [
    0,
    '1px solid #ebebeb',
    '2px solid #ebebeb'
  ],
  colors: {
    yellow: '#fc0',
    red: '#c00',
    berryRed: '#603',
    darkBlue: '#036',
    blue: '#03c',
    green: '#363',
    grays: {
      0: '#999',
      1: '#ebebeb',
      2: '#f8f8f8',
    },
    black: '#000',
    white: '#fff',
    darken: {
      1: 'rgba(0, 0, 0, .2)',
      2: 'rgba(0, 0, 0, .4)',
      3: 'rgba(0, 0, 0, .6)',
      4: 'rgba(0, 0, 0, .8)',
    },
    lighten: {
      1: 'rgba(255, 255, 255, .2)',
      2: 'rgba(255, 255, 255, .4)',
      3: 'rgba(255, 255, 255, .6)',
      4: 'rgba(255, 255, 255, .8)',
      5: 'rgba(255, 255, 255, .95)',
    },
    gradients: {
      greenToGray: 'linear-gradient(135deg, #363, #999)'
    },
    additionalLessonTable: {
      odd: '#f3c8c8',
      even: '#f4e2e5',
      tooltip: '#f8f8ec'
    }
  },
  shadows: {
    insetGreen1: '0 0 0 1px #363',
    insetGreen2: '0 0 0 2px #363',
    insetGray1: '0 0 0 1px #ebebeb',
    insetGray2: '0 0 0 2px #ebebeb',
    outsetDarken1: '0 2px 20px 0 rgba(0, 0, 0, .2)'
  },
  radii: [0, 2, 4]
};

export default theme;


// WEBPACK FOOTER //
// ./src/theme.js